var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('BasePageSection',{attrs:{"bg-color":"#cfebdf"}},[_c('VLayout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('h1',{staticClass:"r-title pa-4"},[_vm._v(" The page timed out while loading. ")]),_c('p',[_vm._v("Please make sure you're still connected to the web and try again.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }